export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Sessions.vue?vue&type=template&id=13e1212a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/sessions/Sessions.vue?vue&type=template&id=13e1212a&scoped=true&
// module id = 1531
// module chunks = 0